module.exports = __webpack_public_path__ + "static/lografLogoBlack-71b176cc286eeb636e8f2f3492add473.svg";